import { Helmet } from 'react-helmet-async';
// sections
import Mainpage from './job-costing-viewpage';
import { useEffect } from 'react';
import { useSearchParams } from 'src/routes/hooks';
// ----------------------------------------------------------------------
export default function JobCostingPage() {
        const searchParams = useSearchParams();
        const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
        const project = searchParams.get('project_id') || localStorage.getItem('projectId') || '';
        const company = searchParams.get('company_id') || localStorage.getItem('companyId') || '';
        useEffect(() => {
            localStorage.setItem('authToken', token);
            localStorage.setItem('projectId', project);
            localStorage.setItem('companyId', company);
        }, [token , project, company]);
    return (
        <>
            <Helmet>
                <title> Job Costing</title>
            </Helmet>
            <Mainpage />
        </>
    );
}
